import type tokens from '@tapsioss/theme/tokens';
import type { KeyType } from 'common/types';

type TokenSurfaceBgColor = Extract<
  KeyType<typeof tokens.color.surface>,
  'primary' | 'secondary' | 'tertiary' | 'disabled' | 'warning' | 'warning-light'
>;

/** Legacy `bg-*` utility suffixes kept for backward compatibility with existing styles. */
type LegacySurfaceBgColor =
  | 'brand'
  | 'brand-light'
  | 'error'
  | 'error-light'
  | 'info'
  | 'info-light'
  | 'success'
  | 'success-light'
  | 'inverse';

type LegacyGradientSurfaceBgColor =
  | 'orange'
  | 'orange-light'
  | 'blue'
  | 'light-blue'
  | 'red'
  | 'light-red'
  | 'gray'
  | 'green'
  | 'light-green'
  | 'white'
  | 'gray-white';

export type SurfaceColor =
  | TokenSurfaceBgColor
  | LegacySurfaceBgColor
  | `gradient-${KeyType<typeof tokens.color.gradient.surface> | LegacyGradientSurfaceBgColor}`
  | 'transparent';

type TokenTextColor = Extract<
  KeyType<typeof tokens.color.content>,
  'primary' | 'secondary' | 'tertiary' | 'disabled' | 'warning'
>;

/** Legacy `color-*` utility suffixes kept for backward compatibility with existing styles. */
type LegacyTextColor = 'inverse' | 'brand' | 'error' | 'info' | 'success';

export type TextColor = TokenTextColor | LegacyTextColor;

export const computeHeight = (height: string | number | undefined, minHeight = false) => {
  if (!height) return {};
  const h = typeof height == 'number' ? `${height}px` : height;
  return { height: h, ...(minHeight ? { minHeight: h } : {}) };
};
export const computeWidth = (width: string | number | undefined, minWidth = false) => {
  if (!width) return {};
  const w = typeof width == 'number' ? `${width}px` : width;
  return { width: w, ...(minWidth ? { minWidth: w } : {}) };
};
